<template>
  <div class="stories">
    <img class="leafs back" src="@/assets/leaves-back-1x.png" srcset="@/assets/leaves-back-1x.png 2000w, @/assets/leaves-back-2x.png 3840w"/>
    <div id="storiesContainer">
      <svg class="speechBubble flatShadow" :style="randomShift()" :data-title="story.title" @click="showStory(story, index)" v-for="story, index in stories" :key="index" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000">
        <defs>
          <path :id="`textpath${index % animals.length}`" :d="animals[index % animals.length].textPath" />
        </defs>
        <path class="button" :d="animals[index % animals.length].path" />
        <text x="500" y="500" text-anchor="middle" alignment-baseline="central">
          <textPath :xlink:href="`#textpath${index % animals.length}`">
            <tspan>{{ story.title }}</tspan>
          </textPath>
        </text>
        <circle v-if="story.nsfw == 1" :cx="animals[index % animals.length].circle.cx" :cy="animals[index % animals.length].circle.cy" :r="animals[index % animals.length].circle.r" />
      </svg>
    </div>

    <story-overlay side="left" />
    <story-overlay side="right" />

    <svg @click="showForm()" class="submitStoryButton button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 921.07 444.11">
      <path d="M531.94,414.05c-13.77-3.06-27.45-3.95-41,.18-17.55,5.36-32,18.69-49.77,23.15-36,9-72.52-20.58-109.17-14.55-13.32,2.2-26.59,9.08-39.68,5.73-15.25-3.9-23.9-20-37.48-28-20.45-12-47-3.18-69.65-10.25-24.92-7.8-39.64-32.51-55.87-53C106,308,75.85,284.73,50.71,256.84c-17.78-19.72-33.38-42.78-40.26-68.72-2-7.61-8.42-29.31-3.82-36.27,6.58-9.95,26.91-1.54,34.53,2.37C88.43,178.49,145.77,197.7,193.31,174c27.13-13.55,46-38.84,66-61.65s44.29-45.06,74.41-48.55c26.38-3,52.81,9,79.17,5.72C438,66.39,459.51,50,484.1,44.09s50.57-.82,75.7-3.94C609.26,34,655-3.46,703.75,6.75c41.08,8.6,68.82,48.58,108.59,62,15.39,5.19,34.11,7.58,42.27,21.63,10.76,18.53-6.06,41.42-24.5,52.36a127.68,127.68,0,0,1-95.8,13.68c15.56,26.35,45.55,40.48,74.84,49.34s60.18,14.23,86.54,29.77c9,5.32,18,12.7,20,23,1.58,8.19-1.63,16.52-5.34,24-22,44.36-65,77.74-113.44,88.09-31,6.63-64.55,4.55-92.75,19.06-24.36,12.54-42.58,36.53-69,43.82C601.2,442.83,566.3,421.68,531.94,414.05Z"/>
      <text text-anchor="left" alignment-baseline="central">
        <tspan x="325" dy="180">Have an online</tspan>
        <tspan x="325" dy="1.25em">dating story you</tspan>
        <tspan x="325" dy="1.25em">would like to</tspan>
        <tspan class="special" x="325" dy="1.25em">share?</tspan>
      </text>
    </svg>
    <story-submission />

    <NavigationArrow link="/clearing" :position="[90, 15]" :rotation="80" color="#bbffd6" />

    <img class="leafs front" src="@/assets/leaves-front-1x.png" srcset="@/assets/leaves-front-1x.png 2000w, @/assets/leaves-front-2x.png 3840w"/>
  </div>
</template>

<script>
import StorySubmission from '@/components/StorySubmission.vue'
import StoryOverlay from '@/components/StoryOverlay.vue'
import NavigationArrow from '@/components/NavigationArrow.vue'

export default {
  components: { StorySubmission, StoryOverlay, NavigationArrow },
  name: 'Stories',
  data () {
    return {
      stories: [
        {
          title: 'No Stories available'
        }
      ],
      animals: [
        {
          path: 'M966.5,229.93c-4.36,10.14-13.1,17.11-18.94,26.21-9.4,14.66-14.35,31.23-12.44,47.81,3.85,33.45-3.08,64.17-16.74,94.22-8.89,19.57-11.1,40.16-5.67,61.15,3.12,12.1,2.06,23.67-1.11,35.69-4.38,16.65-8.16,33.53-15.21,49.22-8.69,19.35-20.23,36.64-37.25,50.35-21.24,17.11-36.3,39.25-47.1,64.35-6.31,14.67-12.73,29.35-20.15,43.48-13.42,25.53-30,49-51.89,68-14.2,12.3-31.76,18.71-49.5,24-24.76,7.33-46.68,19.6-67.21,35.06-17.66,13.3-35.51,26.47-55.82,35.75a108.43,108.43,0,0,1-65.33,8.54c-22.08-3.8-43.3-11-65.38-14.63-18.27-3-36.55-5.11-55.08-3.79-31.38,2.23-58.51-9.37-84.51-25.3-13.08-8-24-18.45-35.17-28.71-9.43-8.7-19.55-16.58-31.36-21.4-50.1-20.42-79.34-59.68-98.42-108.07-6-15.3-14.38-29.51-20.41-44.7-8.37-21.07-21.9-39.42-30.55-60.22A202.66,202.66,0,0,1,66,473.13c.85-11.67-2.15-22.72-3.57-34.07-4.34-34.66-11.27-69.26-2.79-104.35,5.09-21.07,8-42.63,16.37-62.92,3.91-9.48,3.94-20.17,3.92-30.36-.08-35.88,15.39-64.27,41.06-88,.3-.28.63-.52.93-.8,8.43-7.91,8.9-8,11.25,3.29,3.41,16.4,10.52,30.92,20.2,44.42,17.81,24.83,36.09,49.31,57.14,71.51,13.51,14.24,29.7,25.83,41.29,42a139.23,139.23,0,0,0,19.48,21.29c11,10.06,18.51,11.13,31.62,3.93,9.34-5.13,18.65-10.26,27.58-16.15,15-9.86,32.2-14.09,49.44-17.89a23.24,23.24,0,0,0,13.74-8.33c10.56-12.8,21.27-25.52,34.77-35.47,7.25-5.34,12.22-4.12,15.83,4.27,2.75,6.39,5.59,12.81,6.15,19.89.26,3.28,1.3,4.6,5,3.7,21.54-5.2,43.11-4.44,64.57.57,4,.95,7,.3,9.85-2.84a40.23,40.23,0,0,1,7.56-6.25c10.93-7.22,25.53-2.43,26.77,10.48,1.3,13.41,8.87,19.24,19.2,24.54,12,6.15,23,13.79,36.27,17.79,11.28,3.4,21.67,9.64,32.45,14.63,17.34,8,35.17,9.65,53.37,1.56C735.94,336,764.4,319.3,791.7,300.12c18.54-13,37.54-25.72,58.29-35.3,6-2.76,12.41-4.21,18.57-6.42,29.73-10.69,60.3-18.55,90.59-27.33,2.28-.66,4.31-2.62,7-1.7Z',
          circle: {
            cx: '459.99',
            cy: '364.91',
            r: '41.34'
          },
          textPath: 'M80.89,352C176.5,743,679.5,776,847.5,452'
        },
        {
          path: 'M633,202.73c27.64,10.11,63.82,16.85,101.09,19.61a193.7,193.7,0,0,1,102.31,37.77c9.28,6.87,15.36,15.45,20.56,24.6,6.25,11,12.49,22,18.57,33.06,4,7.25,10.49,11.91,18.88,14.61,17.16,5.51,34.63,7.35,52.14,7.05,20.76-.35,23.83,3.06,21.35,20.72-3.57,25.36-8.81,50.28-17.59,74.17-9.1,24.74-21.69,47.66-45.48,64.17a90,90,0,0,1-40.22,15.24c-3.48.47-6.51.94-8.11,4.33-6.44,13.67-16.94,24.82-28.82,34.9-3.74,3.17-3.31,4.25,1.1,7.11a243,243,0,0,1,22,16.27c8,6.62,11.09,14.18,8.44,23.36-6.28,21.85-23.3,35.9-44.55,45.75-26.94,12.5-57,16.4-89.34,9.41-14.85-3.21-26.3-.36-35.7,9.38-15.88,16.46-38.84,23.77-62.2,30.3-4,1.11-10.47.73-10.63,4.76s6.27,5.11,10.21,7c39.62,19,53.93,54.33,32.73,85.07-19.28,28-50.73,44.6-85.93,55.77a406.44,406.44,0,0,1-142.53,18.4c-40.73-1.9-81.64-7.41-120.06-24.39-25.82-11.41-49.32-26.73-73.5-40.83-40.75-23.74-75.54-53-102.66-88.27-28.33-36.85-46.44-75.92-39.39-118.94,2.46-15,8.75-28.3,16.86-41,6.41-10.08,12.9-20.13,19-30.38,7.32-12.3,4-22.54-9.55-32.13-18.54-13.11-40.14-21-60.7-30.68-3.53-1.66-9.33-2-8.72-6.83.54-4.26,5.42-4.1,9.63-4.43,18.94-1.47,37.85-3.09,56.76-4.74,9.64-.84,19.3-1.13,29.17.43,7.1,1.13,13.57.44,18.89-3.48,27.78-20.48,58.77-15.46,90.79-.16,21.26,10.16,38.95,24.92,58.23,37.62,5.81,3.83,7.32,2.68,11.28-1.26,17.51-17.45,8.15-35.89-4.29-53.2a324.76,324.76,0,0,0-88.81-84.19c-43.08-27.78-78.63-62-106-102.07-10.06-14.7-7.56-25.32,8.23-33.2a50.41,50.41,0,0,1,11.85-4.15,756.76,756.76,0,0,1,132-16.66,97.67,97.67,0,0,1,15.09.41c41,4.89,80.07.84,118.68-7,40.32-8.15,81.82-10.88,124.49-1.11C567.82,181.61,596.55,190.8,633,202.73Z',
          circle: {
            cx: '254.7',
            cy: '251.14',
            r: '40.53'
          },
          textPath: 'M145.5,650c294,184,638-102,684-308'
        },
        {
          path: 'M534.69,176.42c47.72-8.49,93.52-8.35,138.44,1.85,54,12.25,104.86,33.16,146.84,70.26,32.38,28.62,55,64.89,72.85,104.24,18.73,41.3,30.71,84.46,39.13,128.87,4.37,23.09,12.68,45.51,14.77,69,6.22,69.66,7.52,139-18.11,206-18.77,49.09-52.47,83.94-99.63,106-18.86,8.81-38.08,17.1-58.88,20.67-49.1,8.42-92.29-2-129.47-37-23.78-22.36-46-45.17-58.51-76-4.2-10.4-6-21.32-8.64-32.08-1.53-6.24-3.65-8.5-10.13-3.68-19.07,14.18-40.63,14.35-62.65,9.1-9.56-2.28-13.24-10.16-14.45-18.79a204.21,204.21,0,0,1-1.62-27.1c-.06-8.77-3.4-15.15-11.76-18-7.54-2.53-11.47,3.33-14.23,8.48-14.72,27.53-36.8,46.4-65.07,59.34-18.21,8.33-25.6,25.88-31.5,43.81-3.78,11.49-6.49,23.33-12.42,34.07-4.59,8.28-10.75,13.9-20.7,13.52-9.51-.36-14.28-7.17-17.4-14.78-8.3-20.29-14.92-41.2-16.32-63.18-1.12-17.6-9.92-22.19-25.16-12.87-25,15.32-51.39,18.41-79.31,17.65-10.81-.29-20.41,3.45-29.28,9.51-9.44,6.44-18.74,13.22-28.72,18.72-12.53,6.91-23.84,4.65-33.62-5.67a15.07,15.07,0,0,0-8.61-4.55,22.43,22.43,0,0,1-18.34-22.05c-.56-40.23,3.84-79.71,16.53-118.2,6.28-19.09,17-35.09,30.62-49.24s23.61-30.11,27.8-49.4c8.67-39.81,29-72.75,58.68-100.29,11.48-10.65,20.39-23.35,27.46-37.2a507.49,507.49,0,0,1,151.1-178.77c26.59-19.79,57.55-28.9,88.65-37.55C494.06,185.26,515,178.69,534.69,176.42Z',
          circle: {
            cx: '733.02',
            cy: '759.88',
            r: '44.53'
          },
          textPath: 'M163.5,730c222-280,618-428,628-72'
        },
        {
          path: 'M795.78,402.14c-4.73-1.87-9.29-4.27-14.16-5.47-11-2.72-22-6.05-33.24-7-26.07-2.15-51.61-7.33-77.36-11.39-24.48-3.86-48.79-8.69-73.48-11.42a340.11,340.11,0,0,1-35.1-5.69c-14.4-3.15-29.28-3-44-3-13.41,0-26.82.7-40.22,1.35-14.61.71-26.31,6.36-33.47,19.47-2.73,5-2.75,6.28,1.14,10.8a27.58,27.58,0,0,0,15.83,8.89c9.62,1.94,19.22,3.93,28.68,6.53,10.11,2.79,20.47,2.38,30.77,2.51,16.25.19,32.54-1.11,48.73.81,32.31,3.82,65,3.77,97.14,9,18.44,3,36.19,8.22,53.82,14,3.43,1.13,6.88,2.2,10.27,3.43a68,68,0,0,0,34.12,3.45c16.53-2.5,33.41-2.59,49.83-6.26a203.23,203.23,0,0,0,29.51-8.93c23.06-9,36.2-26.09,40.9-49.37,1.38-6.87,5-10.31,11-11.82s11.8-.11,15.8,5.3a63.38,63.38,0,0,1,4,5.55c15.41,26.49,26.53,54.1,26.46,85.26,0,13.81,2.56,27.59,2.3,41.52-.17,9,4.61,17,7.19,25.44a299.36,299.36,0,0,0,14.28,37.63c6.55,14.2,3.7,28.25-.18,42.23a86.55,86.55,0,0,1-20.87,36.58c-11.37,12-20,26.23-31.06,38.54-28,31.32-57.22,61.48-92.6,85.17a71.76,71.76,0,0,1-9.21,5.53c-33.16,15.67-64.59,34.61-98.51,48.86-16.11,6.76-32.24,13.48-49.08,18.21s-33.28,10.66-49.54,17c-17.89,7-36.48,10.48-55.69,11.48-13.37.69-26.64,2.92-40.12,1.75-14.91-1.31-29.88-2-44.77-3.62-15.71-1.66-30.92-5.94-45.79-11-15.35-5.22-30.28-11.66-45.55-17.12a218.13,218.13,0,0,1-47.95-24.62c-18.32-12.3-36.23-25.26-52.4-40.3-20.27-18.84-36-41.11-50.09-64.49-8.13-13.54-17.21-26.47-25.42-39.91-8.66-14.17-20.24-25.26-32.63-36.08q-30.39-26.55-59.7-54.27c-15.19-14.4-26.37-31.91-35.69-50.3-14.21-28-23.16-57.82-28-88.73-2.33-14.94-.07-29.67,1.63-44.48C56.3,368,64.41,344.1,72,320c9.14-29.17,23.19-56.06,38.57-82.21a129.32,129.32,0,0,1,54-50.5C173,183,181,178.08,189.84,174.35c15.51-6.58,31.69-10.44,48.13-13.68,3.28-.65,6.54-1.4,9.79-2.2,25.61-6.32,50.38-5.25,74.44,6.91,13.16,6.65,26.34,13,36.54,23.84,2.34,2.49,4.65,2.44,7.63,1.57,11.6-3.39,23.21-6.75,34.89-9.85,19-5,38.41-7.12,57.88-9.44,27.8-3.33,55.11-.5,82.34,4.49,14.25,2.61,27.87,7.55,41.41,12.55,6.05,2.23,12.13,4.31,18.32,6.14,8.7,2.57,17,6.11,24.14,11.77a41.47,41.47,0,0,0,10.83,5.79c15.59,6.07,31,12.45,45.86,20.3a117.85,117.85,0,0,1,30.23,22.28c11.3,11.79,24.64,21.78,33.58,35.66,19.5,30.26,36.6,61.69,47.76,95.9a58.79,58.79,0,0,1,2.28,9.58C796.16,397.84,797.07,399.86,795.78,402.14Z',
          circle: {
            cx: '582.68',
            cy: '275.67',
            r: '40.54'
          },
          textPath: 'M87.5,326c32,108,72,126,124,154s100.78,32.32,141.89,68.66S474.86,688.55,561.18,700.27,727.5,762,907.5,580'
        },
        {
          path: 'M42.16,551.76c15.75-54.85,43.88-103.45,101.72-137,23.68-13.75,71.51-17.55,92.6-4.47,26.67,16.53,27.22,40,22.19,64.07-.57,2.73-2,5.38-2.14,8.13-.93,14.65-1.65,29.32-2.42,44a9.3,9.3,0,0,0,1.35,1.83c3.23,3.28,7.15,2.35,10.25.22,2.91-6.47,6.27-12.89,7.23-19.58,2.94-20.43,5.77-41,5.91-61.59.34-53.94,20.08-104.34,40.53-153.91,15.5-37.58,46.57-67.31,97.87-76.83,15.78-2.92,20.17-12.63,24.32-23.76,5.68-15.29,10.85-31.19,20.33-44.88,20.51-29.64,51.32-45,95.59-41.83,40.32,2.9,68.56,19.28,85.4,48.09s12.6,57.23-13.94,80.65c-21,18.56-43.67,36-66.65,52.91-49.21,36.3-37.95,111.09,21.42,138.73,29.38,13.67,38,11.86,51.62-13.06,16.17-29.61,41.72-52.83,72.08-72.48,47-30.42,118.42-25.68,160.58.1,52.6,32.16,86.57,74.43,92.52,129.9,5.49,51.27-10.43,95.15-57.89,128.59-32.06,22.59-53.52,50.17-69.46,82-17.68,35.27-33.92,71.72-58,104-62.06,83-150.85,135.18-273.66,142.85-20.92,1.31-42.3.54-62.77,3.59-87.26,13-170.5,8.68-245.28-38.06-1.63-1-3.53-1.74-5.27-2.64-46.62-24-78.33-56.43-93.55-100.52C85.43,764,70.23,738.64,58,712.61c-5.89-12.52-14.08-24.93-16.29-37.88C34.69,633.73,30.48,592.44,42.16,551.76Z',
          circle: {
            cx: '532.21',
            cy: '181.62',
            r: '44.82'
          },
          textPath: 'M65.5,576c148,172,438,257.71,825-89.15'
        },
        {
          path: 'M388.37,720.09a16.23,16.23,0,0,0,11,4.27c30,1.31,59.92,4.7,90.05,1.19,26.31-3.07,51.28-11.11,76.23-19.2,22.31-7.23,44.24-16.1,67.37-20,22.22-3.73,44.4-3,62.22,14.38,11,10.74,13.7,26.29,6,39.82-12.77,22.33-31.19,37.95-56.07,45.65-27.88,8.64-56.48,13.28-85.36,17-17.4,2.24-34.59,6.26-51.77,10-22.29,4.8-44.92,5.87-67.55,7.2-25.25,1.49-50,6.43-74.7,11.51-36,7.43-72,5.84-107.95.92-28.09-3.83-50.19-19.26-69.69-38.51-8.32-8.22-17.2-15.25-27.65-20-22.67-10.38-40.15-26.45-54.66-46.45C89.88,705.91,74,684.17,64.56,658.44a137.13,137.13,0,0,1-8.06-48.69c.3-41.94,12.37-80.86,30.89-118C105.17,456.07,127.17,423,149.47,390c16.3-24.09,31.29-49.21,52.4-69.39a637,637,0,0,1,54.68-46.44c14.79-11.25,33-13.6,51.39-14.78,26.28-1.7,48.21,8.26,68.64,23.31,9.84,7.26,20,14.11,29.79,21.42,4,3,7.8,3.45,12.76,2.69,29-4.47,57.45-11.28,86-18,21.61-5.11,43.22-9.65,63.77-18.3a65.34,65.34,0,0,0,11.83-6.88c20.1-13.95,39.94-28.47,64.56-33.74,17.81-3.8,35.83-3.57,54-3.6,21.67,0,42.63,3.44,63.31,9,48.2,13,84.89,41.88,112.56,82.81,6.5,9.61,6.58,9.77,14.61,1.1,4.5-4.86,8.78-9.93,14.24-13.82,9.68-6.89,17.78-5.16,23.29,5.31,6.55,12.46,7.68,26.29,9.61,39.89,3.09,21.83,4.54,43.61-2.86,65-1.16,3.34.07,6.35,1.11,9.59,5.64,17.56,16.15,32.91,22.52,50.13,7.08,19.12,8.55,39.27,10.63,59.23.79,7.5-2.52,15.08-6.7,21.58a37.46,37.46,0,0,0-5.82,13.94c-5,29-36.93,61.25-71,55.21-24.81,6.33-49.67-.16-74.43.46s-49.72,4-73.58,12.17A80.13,80.13,0,0,1,715,641.8c-45.21,2.35-90.47,3.86-135.46,9.48-14.12,1.76-28.5,1.3-42.43,5a67,67,0,0,0-20.85,9.31A384.43,384.43,0,0,1,423.68,712c-7.34,2.5-14.91,3.22-22.38,4.76C397.42,717.58,393.62,718.73,388.37,720.09Z',
          circle: {
            cx: '295.17',
            cy: '321.08',
            r: '35.46'
          },
          textPath: 'M179.85,687.19c63.79,-94.48,317.23,-265.17,709.23,-200.03'
        }

      ]
    }
  },
  async created () {
    this.stories = await this.$store.dispatch('getStories')
  },
  methods: {
    showForm () {
      console.log('showForm')
      this.$store.dispatch('setStorySubmissionFormVisibility', true)
    },
    showStory (story, index) {
      const side = index % 2 === 0 ? 'left' : 'right'
      const data = {
        side: side,
        content: {
          visibility: true,
          title: story.title,
          svg: story.svg
        }
      }

      this.$store.dispatch('setStoryOverlay', data)
    },
    randomShift () {
      const max = 7
      const min = -7
      return `transform: translate(${Math.random() * (max - min + 1) + min}vw, ${Math.random() * (max - min + 1) + min}vh) scale(1.1);`
    }
  }
}
</script>

<style scoped>
  ::-webkit-scrollbar {
      width: 0;
      background: transparent;
  }

  .stories {
    width: 100vw;
    height: 100vh;
    background-color: #006B84;
    background-image: -webkit-image-set(url('~@/assets/stories-bg-1x.png') 1.25x, url('~@/assets/stories-bg-2x.png') 2x);
    background-size: cover;
    overflow-y: auto;
  }

  #storiesContainer {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 70vw;
    margin: 3vh 15vw 20vh;
  }

  svg path {
    fill: #fff;
    stroke: #000;
    stroke-miterlimit: 10;
    stroke-width: 1vh;
  }

  svg.speechBubble {
    min-width: 20vw;
    max-width: 25vw;
    min-height: 20vh;
    max-height: 35vh;
    margin: 5vh 2vw;
    justify-self: center;
    align-self: center;
  }

  svg.speechBubble path {
    fill: #fff;
  }

  svg.speechBubble circle {
    fill: #f15a24;
  }

  svg.speechBubble path,
  svg.speechBubble circle {
    stroke: #000;
    stroke-miterlimit: 10;
    stroke-width: 11px;
  }

  svg.speechBubble text {
    font-size: 100px;
    user-select: none;
    cursor: pointer;
  }

  svg.submitStoryButton {
    position: absolute;
    width: 23vw;
    left: -7vw;
    top: 12vh;
    overflow: visible;
    transform: rotate(325deg);
    z-index: 5;
  }

  svg.submitStoryButton path {
    fill: #6490DD;
    stroke: #fff;
  }

  svg.submitStoryButton text {
    font-size: 46px;
    font-family: 'Courier Prime';
    fill: #fff;
  }

  svg.submitStoryButton tspan.special {
    fill: #4228BF;
  }

  img.leafs {
    position: absolute;
    left: 0;
    width: 100vw;
    pointer-events: none;
  }

  img.leafs.back {
    top: 0vh;
  }

  img.leafs.front {
    bottom: 0vh;
  }

</style>
